import { LocalStorage } from 'quasar';

const qLocalStorage = LocalStorage;
qLocalStorage.setItem = LocalStorage.set;

export { qLocalStorage };
